import React from 'react';
import PageSeo from '@/seo/PageSeo';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import LegalContentFromMarkdown from '../components/Legal/LegalContentFromMarkdown';
import $ from 'jquery';
import LegalDocumentLayout from '../components/Legal/LegalDocumentLayout';

const LegalNotices = () => {
  $('.popover').hide();
  sendGAPageview({ hitType: 'pageview', page: '/Legal', title: 'Legal Notices' });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'legal.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  const sections = [
    { id: 'section1', number: '01', label: 'DTO' },
    { id: 'section2', number: '02', label: 'HPO' },
    { id: 'section3', number: '03', label: 'Uniprot' },
    { id: 'section4', number: '04', label: 'Orphanet' },
    { id: 'section5', number: '05', label: 'GWASCAT' },
    { id: 'section6', number: '06', label: 'NLM MEDLINE' },
    { id: 'section7', number: '07', label: 'CLINICATRIAL.GOV' },
    { id: 'section8', number: '08', label: 'MeSH' },
    { id: 'section9', number: '09', label: 'UMLS' },
    { id: 'section10', number: '10', label: 'NCIT' },
    { id: 'section11', number: '11', label: 'SIO' },
    { id: 'section12', number: '12', label: 'DCMI Metadata' },
    { id: 'section13', number: '13', label: 'MONDO' },
    { id: 'section14', number: '14', label: 'REACTOME PATHWAY DIAGRAM' },
    { id: 'section15', number: '15', label: 'REACTOME PATHWAY ANALYSE SERVICE' },
    { id: 'section16', number: '16', label: 'dbSNP' },
    { id: 'section17', number: '17', label: 'Phewas Catalog' },
    { id: 'section18', number: '18', label: 'Mouse Genome Database (MGD)' },
    { id: 'section19', number: '19', label: 'Rat Genome Database (RGD)' },
    { id: 'section20', number: '20', label: 'FinnGen GWAS' },
    { id: 'section21', number: '21', label: 'UK Biobank GWAS/PheWAS' },
    { id: 'section22', number: '22', label: 'Hancestro Ontology' },
    { id: 'section23', number: '23', label: 'ClinPGx/PharmGKB' },
  ];

  const contactCard = {
    title: 'Contact DISGENET',
    email: 'info@disgenet.com',
    phone: '933037654',
  };

  return (
    <React.Fragment>
      <PageSeo
        title="Licenses and Legal Notices | DISGENET"
        description="Third-party licenses and legal notices for data sources integrated in the DISGENET gene-disease association database."
        path="/Legal"
      />
      <section>
        <LegalDocumentLayout
          heroTag="Legal"
          heroTitle={
            <>
              Data sources and <em>licensing</em> information
            </>
          }
          heroSubtitle="Explore all third-party datasets and legal references incorporated into DISGENET."
          sections={sections}
          contact={contactCard}
          onDownload={downloadSummary}
        >
          <LegalContentFromMarkdown />
        </LegalDocumentLayout>
      </section>
    </React.Fragment>
  );
};

export default LegalNotices;
